import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../Button/Button";

export const ResultadosPorMes = (props) => {
    const year = Number(props.match.params.anio);
    const [resultados, setresultados] = useState([]);

    useEffect(() => {
        const asyncFunction = async () => {
        const endpoint = await (await fetch('/api/show_endpoints/wsresultadosactos')).json();
        const brand = await (await fetch('/api/get_brand')).json();
        fetch(
            `${endpoint.url_base}${endpoint.url_variable}?Brand=${brand.nombre}&Anios=6`,
            {
                cache: 'no-cache'
            }
        )
            .then((response) => response.json())
            .then((json) => {
                let actos = json.Actos.Acto.filter((acto) => acto.Anio == year);
                let actosAMostrar = actos.filter(
                    (acto) => acto.Url !== "No existe el PDF"
                );
                actosAMostrar.sort(function comparar(a, b) {
                    return a.AnioMes - b.AnioMes;
                });
                setresultados(actosAMostrar);
            });
        }
        asyncFunction();
    }, []);

    console.log(resultados);

    return (
        <div className="resultadosContainer">
            <div className="resultadosContainer--mainDiv">
                <div className="title">
                    <div className="title--container">
                        <Link to={"/acto_de_adjudicacion"}>
                            Acto de Adjudicación
                        </Link>
                    </div>
                </div>
                <div className="subtitle">
                    <div className="subtitle--container">
                        <p>Resultados por mes</p>
                        <img src="/images/icons/arrow-right.svg" />
                        <p className="font-weight-bold">{year}</p>
                    </div>
                </div>
            </div>
            <div className="resultadosContainer--secondDiv">
                {resultados.length !== 0 ? (
                    <div className="innerDiv">
                        {resultados.map((resultado) => (
                            <Button
                                key={resultado.AnioMes}
                                className="btn-acto"
                                img="/images/icons/download.svg"
                                text={resultado.Mes}
                                pdf={resultado.Url}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="spinner-loader">
                        <div
                            className="spinner-border text-bordo mt-dbhf mb-doub align-self-center"
                            role="status"
                        >
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
